import LoginScreen from 'App/Authentication/LoginScreen'
import TermsScreen from 'App/Authentication/TermsScreen'
import { Switch, Route, Redirect } from 'react-router-dom'
import { LoginCallback } from '@okta/okta-react'

function Authentication() {
  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/login" />} />
      <Route path="/login" component={LoginScreen} />
      <Route path="/auth/dnb/callback" component={LoginCallback} />
      <Route
        path="/signup"
        render={() => {
          window.location.href = 'https://www.netwisedata.com/sign-up/'
          return null
        }}
      />
      <Route path="/terms" component={TermsScreen} />
      <Route
        path="/"
        render={({ history, location }) => {
          const { pathname, search } = location
          history.replace('/login?next=' + pathname + search)
          return null
        }}
      />
    </Switch>
  )
}

export default Authentication
